import React from "react";

import useMediaQuery from "../../hooks/useMediaQuery";

import Header from "./Header";
import NavBottom from "./NavBottom";

const Layout = ({ children }) => {
  const isMobile = useMediaQuery("max-width", 500);

  return (
    <div style={{ backgroundColor: "#f1f1f1", height: "100%" }}>
      <Header />
      <div style={{ height: "100%", marginTop: "70px" }}>{children}</div>
      {isMobile && <NavBottom />}
    </div>
  );
};

export default Layout;
